export const purpleLine = {
    label: '',
    fill: true,
    borderColor: "#E697FF",
    pointBorderColor: "#E697FF",
    backgroundColor: "rgba(243, 205, 255, 0.5)",
    pointRadius: 3,
    pointHoverRadius: 6,
    pointBorderWidth: 6,
    data: []
};

export const blueLine = {
    label: '',
    fill: true,
    borderColor: "#3C81FB",
    pointBorderColor: "#3C81FB",
    backgroundColor: "rgba(60, 129, 251, 0.32)",
    pointRadius: 3,
    pointHoverRadius: 6,
    pointBorderWidth: 6,
    data: []
};

export const defaultData = {
    datasets: [blueLine, purpleLine]
}

export const defaultOptions = {
    legend: {
        display: false
    },
    tooltips: {
        mode: "point"
    },
    scales: {
        xAxes: [{
            type: "time",
            time: {
                unit: "day",
                parser: "YYYYMMDD",
                displayFormats: {
                    millisecond: "D MMMM",
                    second: "D MMMM",
                    minute: "D MMMM",
                    hour: "D MMMM",
                    day: "D MMMM"
                },
                tooltipFormat: "D MMMM YYYY",
            },
            distribution: "linear",
        }],
        yAxes: [{
            ticks: {
                beginAtZero: true,
                callback(value) {
                    return Number(value).toLocaleString()
                },
            },
            scaleLabel: {
                display: true,
                labelString: ''
            }
        }]
    }
}
